import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'payment-timeline-actions',
  standalone: true,
  imports: [CommonModule, ButtonModule, PopoverModule, TranslateModule],
  templateUrl: './payment-timeline-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentTimelineActionsComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null) // expected data ["edit","active","inactive"] etc
  @Input() rowIndex = 0;
  @Output() onAction = new EventEmitter(); // {type:actionName,columnData }

  constructor() { }

  ngOnInit(): void {
  }

  executeAction(action: string, columnData: any, overlayElement: any) {
    overlayElement.hide();
    this.onAction.emit({ action, columnData: columnData, rowIndex: this.rowIndex });
  }

  canShowRetry(columnData: any): boolean {
    const status = columnData?.status?.toLowerCase();
    const paymentStatus = columnData?.payment_status?.toLowerCase();
    const totalPayment = columnData?.total_payment_in_minor_currency;
    const occurance = columnData?.occurance;
    const isRecurring = columnData?.is_recurring;
    return (status === "open" && totalPayment === 0 && isRecurring) || (paymentStatus === "failed" && occurance !== 1);
}

}

